import { getAccountScopeUserSettings } from "owa-session-store";
import type { MailboxInfo } from "owa-client-types";
import { isMailboxSharedResourceArchive } from "owa-account-shared-mailbox-utils";

/**
 * Get the primary from email address, i.e. the address used to initially create the account
 */
export default function getPrimaryFromAddress(mailboxInfo: MailboxInfo): string {
    if (isMailboxSharedResourceArchive(mailboxInfo) &&
        mailboxInfo.explicitLogonMailboxSmtpAddress) {
        return mailboxInfo.explicitLogonMailboxSmtpAddress;
    }
    return getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress ?? "";
}
